import { render, staticRenderFns } from "./DiagnosisInsights.vue?vue&type=template&id=c5ac5b9c&scoped=true"
import script from "./DiagnosisInsights.vue?vue&type=script&lang=js"
export * from "./DiagnosisInsights.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisInsights.vue?vue&type=style&index=0&id=c5ac5b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ac5b9c",
  null
  
)

export default component.exports